import React from 'react';
//import PropTypes from 'prop-types';

import { CartStepsDeliveryWidget } from './CartStepsDeliveryWidget';


const RawCartSteps = (props) => {
  return <CartStepsDeliveryWidget {...props} />;
};

RawCartSteps.defaultProps = {};

RawCartSteps.propTypes = {
};

export const CartSteps = RawCartSteps;
